// extracted by mini-css-extract-plugin
module.exports = {"averageMarketLeveraging":"style_averageMarketLeveraging__2SLvv"};